function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.206 4.758c1.885-1.853 4.943-1.853 6.828 0l3.307 3.253a4.692 4.692 0 010 6.714L16.57 26.31a2.421 2.421 0 01-3.383 0L1.414 14.725a4.691 4.691 0 010-6.714l3.307-3.253c1.886-1.853 4.943-1.853 6.828 0l3.329 3.274 3.328-3.274z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "3",
  width: "30",
  height: "24"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.206 4.758c1.885-1.853 4.943-1.853 6.828 0l3.307 3.253a4.692 4.692 0 010 6.714L16.57 26.31a2.421 2.421 0 01-3.383 0L1.414 14.725a4.691 4.691 0 010-6.714l3.307-3.253c1.886-1.853 4.943-1.853 6.828 0l3.329 3.274 3.328-3.274z",
  fill: "currentColor"
}))));